import axios from 'axios';
// import store from '../store';

function errorHandler(error, reject) {
    console.log(error);
    if (error.response && error.response.data) {
        reject(error.response.data);
    } else {
        reject(error);
    }
}

export default {
    customeraktif() {
        return new Promise(async (resolve, reject) => {
            try {
                const {data} = await axios.get('/bakerycustomer?page=1&limit=1000&blocked=0');
                resolve(data.list);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    supplieraktif() {
        return new Promise(async (resolve, reject) => {
            try {
                const {data} = await axios.get('/bakerysupplier?page=1&limit=1000');
                resolve(data.list);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    itemaktif() {
        return new Promise(async (resolve, reject) => {
            try {
                const {data} = await axios.get('/bakeryitem?page=1&limit=1000&isactive=1&headcategory=BREAD');
                resolve(data.list);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    currency() {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.get("/currency/cbo");
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    customerkonsixls(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['tgl1', 'tgl2', 'customer', 'customer_id', 'dggroup', 'itemcategory', 'customer_group'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const resp = await axios({
                    url: `/bakeryreport/customerkonsixls${str}`,
                    method: 'GET',
                    responseType: 'blob', // important
                });
                resolve(resp);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    }, 

    customerkonsi(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'tgl1', 'tgl2','viewoption', 'customer', 'customer_id', 'status', 'dggroup', 'item', 'itemcategory', 'customer_group'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                let url = '/bakeryreport/customerkonsi';
                const {data} = await axios.get(`${url}${str}`);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },

    customerdelivery(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'tgl1', 'tgl2','viewoption', 'customer', 'customer_id', 'customer_group', 'status', 'dggroup', 'item', 'itemcategory'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                let url = '/bakeryreport/customerdelivery';
                const {data} = await axios.get(`${url}${str}`);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    }, 
    customerdeliveryxls(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['tgl1', 'tgl2', 'customer', 'customer_id', 'customer_group', 'status', 'dggroup', 'item', 'itemcategory'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const resp = await axios({
                    url: `/bakeryreport/customerdeliveryxls${str}`,
                    method: 'GET',
                    responseType: 'blob', // important
                });
                resolve(resp);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    }, 
    customerdeliveryitemxls(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['tgl1', 'tgl2', 'customer', 'customer_id', 'status', 'dggroup', 'item', 'itemcategory'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const resp = await axios({
                    url: `/bakeryreport/customerdeliveryitemxls${str}`,
                    method: 'GET',
                    responseType: 'blob', // important
                });
                resolve(resp);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    fcVendor(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'tgl1', 'tgl2','viewoption', 'vendorinfo', 'vendor_id', 'status', 'dggroup', 'item'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                let url = '/bakeryreport/fcVendor';
                const {data} = await axios.get(`${url}${str}`);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    supplierreceivingxls(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['tgl1', 'tgl2', 'vendor', 'vendor_id'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const resp = await axios({
                    url: `/bakeryreport/supplierreceivingxls${str}`,
                    method: 'GET',
                    responseType: 'blob', // important
                });
                resolve(resp);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    }, 
    
    supplierreceiving(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'tgl1', 'tgl2','viewoption', 'vendorinfo', 'vendor_id', 'vendor', 'status', 'dggroup', 'item'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                let url = '/bakeryreport/supplierreceiving';
                const {data} = await axios.get(`${url}${str}`);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },

    fcCustomer(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'tgl1', 'tgl2','viewoption', 'customer', 'customer_id', 'status', 'dggroup', 'item'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                let url = '/bakeryreport/fcCustomer';
                const {data} = await axios.get(`${url}${str}`);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },

};